import React from 'react';
import PropTypes from 'prop-types';
import styles from './Contract.scss';
import SignaturePad from 'react-signature-canvas';

export default class SignaturePadComponent extends React.Component {

  static propTypes = {
    showError: PropTypes.bool,
    legalNotice: PropTypes.node,
    updateSignaturePadRef: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      signaturePadDimensions: { width: 0, height: 0 }
    };
    this.updateSignaturePadDimensions = this.updateSignaturePadDimensions.bind(
      this
    );
  }

  componentDidMount() {
    this.updateSignaturePadDimensions();
    this.props.updateSignaturePadRef(this.refs.signaturePad);
    window.addEventListener('resize', this.updateSignaturePadDimensions);
    window.addEventListener('orientationchange', this.updateSignaturePadDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSignaturePadDimensions);
    window.removeEventListener('orientationchange', this.updateSignaturePadDimensions);
  }

  updateSignaturePadDimensions() {
    const sigContainer = this.refs.sigContainer;
    // We add a setTimeout here so that we can get the
    // dimensions of the signature container after resize has completed
    setTimeout(() => {
      this.setState((state) => (Object.assign({}, state, {
        signaturePadDimensions: {
          width: window.innerWidth > window.innerHeight ? sigContainer.offsetWidth : sigContainer.offsetHeight,
          height: window.innerWidth > window.innerHeight ? sigContainer.offsetHeight : sigContainer.offsetWidth,
        }
      })));
    }, 250);
  }

  render() {
    return (
      <div>
        <div className={styles.sigContainer} ref='sigContainer'>
          <div style={window.innerWidth > window.innerHeight ? {} : { transform: 'rotate(90deg)' }}>
            <SignaturePad
              canvasProps={{
                className: this.props.showError ? styles.signatureError : '',
                width: this.state.signaturePadDimensions.width,
                height: this.state.signaturePadDimensions.height
              }}
              ref='signaturePad'
            />
          </div>
          <span
            onClick={() => {
              if (this.refs.signaturePad) this.refs.signaturePad.clear();
            }}
            className={styles.signaturePadReset}
          >
            Clear
          </span>
          <span className={styles.signatureLine}>&times;</span>
          {this.props.legalNotice}
        </div>
        {this.props.showError &&
          <div className={styles.signatureErrorText}>
            Signature is required
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/SignaturePad.js